<template>
    <div class="d-flex align-items-center text-md-start ms-md-4" :class="{optional_class, 'text-center': !title}">
        <template v-if="title">
            <div class="title me-2" :class="optional_title_class">
                <i class="bi bi-square-fill"></i> {{ title }}
            </div>
        </template>
        <div class="flex-grow-1 d-flex gap-2 multiline" :class="optional_text_class">
            {{ text }}
            <slot/>
        </div>
    </div>
</template>

<script>
export default {
    name: 'SummaryBoxRow',
    props: {
        title: {
            type: String,
            default: ''
        },
        text: {
            type: [String, Number],
            default: ''
        },
        optional_class: {
            type: String,
            default: ''
        },
        optional_title_class: {
            type: String,
            default: ''
        },
        optional_text_class: {
            type: String,
            default: ''
        },
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    .col {white-space: pre-line;}
    .title {color: #777; font-size: .97rem; font-weight: bold;}
    .bi {color: #888; font-size: .9rem;}
    /* @include media-breakpoint-up(sm) {
        .col {
            margin-left: block;
        }
    } */
</style>
